import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ADMIN_API_BASE = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "flatch_admin_token";

export function getAdminToken() {
    return typeof window !== "undefined" ? localStorage.getItem(ADMIN_TOKEN_KEY) : null;
}

export function setAdminToken(t) {
    if (typeof window === "undefined") return;
    if (t) localStorage.setItem(ADMIN_TOKEN_KEY, t);
    else localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function clearAdminToken() {
    setAdminToken(null);
}

export const adminApi = axios.create({
    baseURL: ADMIN_API_BASE,
    withCredentials: false,
});

adminApi.interceptors.request.use((config) => {
    const t = getAdminToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

adminApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            clearAdminToken();
            if (typeof window !== "undefined" && !window.location.pathname.endsWith("/admin/login")) {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(err);
    },
);
